@if (station()) {
  <div class="is-flex is-space-between">
    <div class="is-flex is-column gap-8 is-flex-grow-1">
      <app-text class="text-14 is-family-semiBold">{{ 'common.__HUMIDITY' | AsyncLang | async }}</app-text>
      <div class="is-flex is-align-baseline gap-4">
        <app-text class="inline text-blue text-18 is-family-medium">{{
          (getValue() | toDisplayValue: type) ?? '--'
        }}</app-text>
        <app-text class="inline text-grey-50 is-family-semiBold" unit [measureType]="type" />
      </div>
    </div>
    <app-preview-graph [data]="[station().Humidity]" color="var(--blue)" [measureType]="type" />
  </div>
}
